"use client"

import { Quote, Star } from "lucide-react"

import { GlassCard } from "@shared/ui/landing/glass-card"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { voiceReviews } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

export function VoicesSection() {
  const t = useTranslations("voices")

  return (
    <SectionContainer id="voices" className="py-12 md:py-20">
      <div className="mb-8 space-y-2 text-center md:mb-12">
        <h2 className="text-2xl font-bold tracking-tight md:text-3xl">{t("title")}</h2>
        <p className="mx-auto max-w-2xl text-muted-foreground">{t("subtitle")}</p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        {voiceReviews.map((review) => (
          <GlassCard key={review.id} className="cyber-border relative">
            <Quote className="mb-4 size-8 text-sky-500/30" />
            <p className="text-sm leading-relaxed text-muted-foreground">
              &ldquo;{t(review.quoteKey)}&rdquo;
            </p>
            <div className="mt-6 flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  className={`size-3.5 ${
                    i < review.rating
                      ? "fill-amber-400 text-amber-400"
                      : "text-white/20"
                  }`}
                />
              ))}
            </div>
            <div className="mt-4 border-t border-white/5 pt-4">
              <p className="text-sm font-medium">{t(review.nameKey)}</p>
              <p className="text-xs text-muted-foreground">{t(review.roleKey)}</p>
            </div>
          </GlassCard>
        ))}
      </div>
    </SectionContainer>
  )
}
